import auth from './auth'

export default {
    guest (to, from, next) {
        next(!auth.check())
    },

    auth (to, from, next) {
        next(auth.check() ? true : {
            path: '/inicio'
        })
    }
}